/**
 * VALIDATION STORE
 */

import app from "Main";
import * as rules_forms from "./validation.data.js";

const state = {
    ...rules_forms.default,
    validRange: {
        password: {
            min: 8,
            max: 16,
        },
        username: {
            min: 8,
            max: 100,
        },
    },
    regex: {
        // email: /^(?=.{1,254}$)([\w\.\-]{1,64})@([\w\-]+)((\.(\w){2,})+)$/,
        email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
        username: /[^A-Za-z0-9@.]/,
        password: /[^A-Za-z0-9!@#$%^&*]/,
        url: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
    },
    validate_state: false,
};

// getters
const getters = {
    validate_state: (state) => {
        return state.validate_state;
    },
    $r: (state) => {
        return {
            unsigned() {
                let regexTest = new RegExp("^-\\d+\\.\\d{3}$");
                return [(v) => !regexTest.test(v) || `${app.$i18n.t("lang.unsigned")}`];
            },
            min_value(minVal) {
                return [(v) => +v >= minVal || `${app.$i18n.t("lang.min_is")} ${minVal}`];
            },
            max_value(maxVal) {
                return [(v) => +v <= maxVal || `${app.$i18n.t("lang.max_is")} ${maxVal}`];
            },
            min_length(minLen) {
                return [(v) => (v || "").length >= minLen || `${app.$i18n.t("lang.min_length_is")} ${minLen}`];
            },
            max_length(maxLen) {
                return [(v) => (v || "").length <= maxLen || `${app.$i18n.t("lang.max_length_is")} ${maxLen}`];
            },
            exact_length(matchLen) {
                return [(v) => (v || "").length == matchLen || `${app.$i18n.t("lang.length_must_be")} ${matchLen}`];
            },
            is_unique(list) {
                return [(v) => !v || !(list || []).includes(v.toLowerCase()) || app.$i18n.t("lang.not_unique")];
            },
            required(trim, type) {
                return [
                    (v) =>
                        typeof v == "number" ||
                        (_.isObject(v) ? !_.isEmpty(v) : trim ? !!(v || "").trim() : !!v) ||
                        `${app.$i18n.t("lang.required")}${type ? " " + type : ""}`,
                ];
            },
            valid_email() {
                return [(v) => !v || state.regex.email.test(v) || `${app.$i18n.t("lang.required_email")} - test@example.com`];
            },
            valid_url() {
                return [(v) => !v || state.regex.url.test(v) || app.$i18n.t("lang.required_url")];
            },
            regex_match(pattern) {
                // console.log('pattern', pattern)
                let testingRegex = new RegExp(`[^${pattern}]`, "gm");
                // console.log(testingRegex.test('test|test'))
                return [(v) => !testingRegex.test(v) || `${app.$i18n.t("lang.invalid_characters")}: ${[...v.match(testingRegex)].join("")}`];
            },
            valid_username() {
                return [
                    (v) => !!v || app.$i18n.t("lang.required"),
                    (v) => (v || "").length >= state.validRange.username.min || `${app.$i18n.t("lang.min_length_is")} ${state.validRange.username.min}`,
                    (v) => (v || "").length <= state.validRange.username.max || `${app.$i18n.t("lang.max_length_is")} ${state.validRange.username.max}`,
                    (v) => !state.regex.username.test(v) || `${app.$i18n.t("lang.invalid_characters")}: ${[...v.match(state.regex.username)].join("")}`,
                    (v) => (v && v.indexOf("@") == -1 && v.indexOf(".") == -1) || state.regex.email.test(v) || app.$i18n.t("lang.invalid_email_format"),
                ];
            },
            valid_password() {
                return [
                    (v) => !!v || app.$i18n.t("lang.required"),
                    (v) => /[A-Z]+/.test(v) || app.$i18n.t("lang.require_one_caps"),
                    (v) => /[a-z]+/.test(v) || app.$i18n.t("lang.require_one_lowercase"),
                    (v) => /[0-9]+/.test(v) || app.$i18n.t("lang.require_one_number"),
                    (v) => /[!@#$%^&*]+/.test(v) || app.$i18n.t("lang.require_one_special"),
                    (v) => !state.regex.password.test(v) || `${app.$i18n.t("lang.invalid_characters")}: ${[...v.match(state.regex.password)].join("")}`,
                    (v) => (v || "").length >= state.validRange.password.min || `${app.$i18n.t("lang.min_length_is")} ${state.validRange.password.min}`,
                    (v) => (v || "").length <= state.validRange.password.max || `${app.$i18n.t("lang.max_length_is")} ${state.validRange.password.max}`,
                ];
            },
            matches(match) {
                return [(v) => (v && v == (match.value || "")) || `${app.$i18n.t("lang.must_match")} ${match.name || ""}`];
            },
            less_than(less_than) {
                return [
                    (v) =>
                        !v ||
                        !less_than.value ||
                        (less_than && !!less_than.value && v && +v < (+less_than.value || "")) ||
                        `${app.$i18n.t("lang.must_be_less_than")} ${less_than.name || ""}`,
                ];
            },
            greater_than(greater_than) {
                return [
                    (v) =>
                        !v ||
                        !greater_than.value ||
                        (greater_than && !!greater_than.value && v && +v > (+greater_than.value || "")) ||
                        `${app.$i18n.t("lang.must_be_greater_than")} ${greater_than.name || ""}`,
                ];
            },
            integer() {
                return [(v) => !v || v == parseInt(v, 10) || app.$i18n.t("lang.number_required")];
            },
            decimal() {
                return [(v) => !v || (!isNaN(parseFloat(v)) && isFinite(v)) || app.$i18n.t("lang.decimal_required")];
            },
            requires_dependency(dependency) {
                return [(v) => !dependency.value || (!!v && !!dependency.value) || app.$i18n.t("lang.required")];
            },
            numeric(decimals = null) {
                return [
                    (v) => !v || isFinite(v) || app.$i18n.t("lang.number_required"),
                    (v) => !v || decimals == null || app.countDecimals(+v) <= decimals || `${app.$i18n.t("lang.decimals_allowed")}: ${decimals}`,
                ];
            },
            // list_requirements = comma separated values for [amount_required, max_allowed]
            require_list(list_requirements) {
                list_requirements = list_requirements.split(",");
                let min_required = list_requirements[0];
                let max_allowed = list_requirements.length > 1 ? list_requirements[1] : null;
                let final_list = [];
                let test = (el) => {
                    if (el.length > 0) {
                        if (el[0] == "|" || el[el.length - 1] == "|") {
                            return app.$i18n.t("lang.no_pipe_at_ends");
                        }
                        let list = el.split("|");
                        let spaces = list.filter((item) => item.trim().length == 0 || item[0] == " " || item[item.length - 1] == " ");
                        if (spaces.length > 0) {
                            return app.$i18n.t("lang.items_no_space_at_ends");
                        }
                        final_list = list.filter((item) => item.trim().length > 0 && item[0] != " " && item[item.length - 1] != " ");
                        return final_list.length >= min_required;
                    } else {
                        return [true];
                    }
                };
                return [
                    (v) => !v || (!!v && test(v)) || `${app.$i18n.t("lang.required_piped_list")}: ${min_required}${!max_allowed ? "+" : ""}`,
                    (v) =>
                        !v ||
                        !max_allowed ||
                        (!!v && !!max_allowed && final_list.length == max_allowed) ||
                        `${app.$i18n.t("lang.required_piped_list")}: ${max_allowed}`,
                    (v) => !v || (!!v && new Set(final_list).size == final_list.length) || app.$i18n.t("lang.items_must_be_unique"),
                ];
            },

            //OLD LIST BELOW
            //DONT USE ANY OF THESE

            minVal(minVal) {
                return [(v) => +v >= minVal || `${app.$i18n.t("lang.min_is")} ${minVal}`];
            },
            maxVal(maxVal) {
                return [(v) => +v <= maxVal || `${app.$i18n.t("lang.max_is")} ${maxVal}`];
            },
            minLen(minLen) {
                return [(v) => (v || "").length >= minLen || `${app.$i18n.t("lang.min_length_is")} ${minLen}`];
            },
            maxLen(maxLen) {
                return [(v) => (v || "").length <= maxLen || `${app.$i18n.t("lang.max_length_is")} ${maxLen}`];
            },
            isLen(matchLen) {
                return [(v) => (v || "").length == matchLen || `${app.$i18n.t("lang.length_must_be")} ${matchLen}`];
            },
            confirmPassword(match) {
                return [
                    (v) => (v && v == match) || app.$i18n.t("lang.passwords_must_match"),
                    (v) => (v || "").length <= state.validRange.password.max || `${app.$i18n.t("lang.max_length_is")} ${state.validRange.password.max}`,
                ];
            },
            testAllowedCharset(charset) {
                let testingRegex = new RegExp(`[^${charset}]`, "gm");
                return [(v) => !testingRegex.test(v) || `${app.$i18n.t("lang.invalid_characters")}: ${[...v.match(testingRegex)].join("")}`];
            },
            username: [
                (v) => !!v || app.$i18n.t("lang.required"),
                (v) => (v || "").length >= state.validRange.username.min || `${app.$i18n.t("lang.min_length_is")} ${state.validRange.username.min}`,
                (v) => (v || "").length <= state.validRange.username.max || `${app.$i18n.t("lang.max_length_is")} ${state.validRange.username.max}`,
                (v) => !state.regex.username.test(v) || `${app.$i18n.t("lang.invalid_characters")}: ${[...v.match(state.regex.username)].join("")}`,
                (v) => (v && v.indexOf("@") == -1 && v.indexOf(".") == -1) || state.regex.email.test(v) || app.$i18n.t("lang.invalid_email_format"),
            ],
            req: [(v) => typeof v == "number" || !!v || app.$i18n.t("lang.required")],
            emailRegex: state.regex.email,
            email: [(v) => !v || state.regex.email.test(v) || app.$i18n.t("lang.required_email")],
            password: [
                (v) => !!v || app.$i18n.t("lang.required"),
                (v) => /[A-Z]+/.test(v) || app.$i18n.t("lang.require_one_caps"),
                (v) => /[a-z]+/.test(v) || app.$i18n.t("lang.require_one_lowercase"),
                (v) => /[0-9]+/.test(v) || app.$i18n.t("lang.require_one_number"),
                (v) => /[!@#$%^&*]+/.test(v) || app.$i18n.t("lang.require_one_special"),
                (v) => !state.regex.password.test(v) || `${app.$i18n.t("lang.invalid_characters")}: ${[...v.match(state.regex.password)].join("")}`,
                (v) => (v || "").length >= state.validRange.password.min || `${app.$i18n.t("lang.min_length_is")} ${state.validRange.password.min}`,
                (v) => (v || "").length <= state.validRange.password.max || `${app.$i18n.t("lang.max_length_is")} ${state.validRange.password.max}`,
            ],
            ranges: state.validRange,
        };
    },
};

// mutations
const mutations = {
    validationOn(state) {
        state.validate_state = true;
    },
    validationOff(state) {
        state.validate_state = false;
    },
};
export default {
    state,
    getters,
    mutations,
};
